import Grid from "@mui/material/Grid";

const AgentButtons = ({
  previewAgent,
  rendersecondaryBtnTextColor,
  rendersecondaryBtnColor,
  rendersecondaryBtnFontFamily,
  rendersecondaryBtnFontSize,
  rendersecondaryBtnFontWeight,
  rendersecondaryBtnFontStyle,
  rendersecondaryBtnBorderRadius,
  rendersecondaryBtnBorderColor,
  renderprimayBtnTextColor,
  renderprimayBtnColor,
  renderprimayBtnFontFamily,
  renderprimayBtnFontSize,
  renderprimayBtnFontWeight,
  renderprimayBtnFontStyle,
  renderprimayBtnBorderRadius,
  renderprimayBtnBorderColor,
}: any) => {
  return (
    <Grid
      container
      justifyContent="space-between"
      mt={previewAgent ? "60px" : "20px"}
    >
      <button
        type="button"
        style={{
          marginTop: "20px",
          marginBottom: "15px",
          color: rendersecondaryBtnTextColor(),
          backgroundColor: rendersecondaryBtnColor(),
          fontFamily: rendersecondaryBtnFontFamily(),
          fontSize: rendersecondaryBtnFontSize(),
          fontWeight: rendersecondaryBtnFontWeight(),
          fontStyle: rendersecondaryBtnFontStyle(),
          textTransform: "none",
          width: previewAgent ? "49%" : "48%",
          marginRight: "10px",
          padding: "10px",
          borderRadius: rendersecondaryBtnBorderRadius(),
          border: `1px solid ${rendersecondaryBtnBorderColor()}`,
        }}
      >
        Back
      </button>
      <button
        type="button"
        style={{
          marginTop: "20px",
          marginBottom: "15px",
          color: renderprimayBtnTextColor(),
          backgroundColor: renderprimayBtnColor(),
          fontFamily: renderprimayBtnFontFamily(),
          fontSize: renderprimayBtnFontSize(),
          fontWeight: renderprimayBtnFontWeight(),
          fontStyle: renderprimayBtnFontStyle(),
          textTransform: "none",
          width: previewAgent ? "49%" : "48%",
          padding: "10px",
          borderRadius: renderprimayBtnBorderRadius(),
          border: `1px solid ${renderprimayBtnBorderColor()}`,
        }}
      >
        Send feedback
      </button>
    </Grid>
  );
};

export default AgentButtons;
